export default {
	locationAlert: require('../../assets/icons/locationAlert/location.png'),
	clockLogin: require('../../assets/icons/clockLogin/clockLogin.png'),
	clockLoginPrimary: require('../../assets/icons/clockLogin/clockLoginPrimary.png'),
	clockLoginWhite: require('../../assets/icons/whiteLogoClockIn/white-logo-clock-in.png'),
	clockLoginWhite1p5: require('../../assets/icons/whiteLogoClockIn/white-logo-clock-in-1p5.png'),
	remove: require('../../assets/icons/remove/remove.png'),
	play: require('../../assets/icons/play/player-play-filled.png'),
	stop: require('../../assets/icons/stop/player-stop-filled.png'),
	noRecords: require('../../assets/icons/noRecords/noRecords.png'),
	location: require('../../assets/icons/location/location.png'),
	starPlaceholder: require('../../assets/icons/star-placeholder/star-md.png'),
	roundPlus: require('../../assets/icons/roundPlus/addBtn.png'),
	mail: require('../../assets/icons/mail/mail.png'),
	down: require('../../assets/icons/down/down.png'),
	up: require('../../assets/icons/up/up.png'),
	exclamation: require('../../assets/icons/exclamation/exclamation.png'),
	edit: require('../../assets/icons/edit/edit.png'),
	pencilEdit: require('../../assets/icons/edit/pencil_edit.png'),
	editPencil: require('../../assets/icons/edit/editPP.png'),
	tick: require('../../assets/icons/v/v.png'),
	delete: require('../../assets/icons/delete/delete.png'),
	error: require('../../assets/icons/snackbarIcons/alert-circle-filled.png'),
	success: require('../../assets/icons/snackbarIcons/success.png'),
	info: require('../../assets/icons/snackbarIcons/info.png'),
	alertCircle: require('../../assets/icons/alert-circle/alert-circle.png'),
	circleCheck: require('../../assets/icons/circle-check/circle-check.png'),
	clipboardText: require('../../assets/icons/clipboard-text/clipboard-text.png'),
	plus: require('../../assets/icons/plus/plus.png'),
	primaryColorPlus: require('../../assets/icons/plus/primaryColorPlus.png'),
	minus: require('../../assets/icons/minus/minus.png'),
	primaryColorMinus: require('../../assets/icons/minus/primaryColorMinus.png'),
	lock: require('../../assets/icons/lock/lock.png'),
	user: require('../../assets/icons/user/user.png'),
	userCircle: require('../../assets/icons/user/user-circle.svg'),
	userCirclePng: require('../../assets/icons/user/user-circle-png.png'),
	clockInLogo: require('../../assets/icons/clockInLogo/clockInLogo_2.png'),
	michpal: require('../../assets/icons/michpalLogo/logo-michpal.png'),
	Michpal_LG: require('../../assets/icons/michpalLogo/new-logo-michpal-2.png'),
	Michpal_SM: require('../../assets/icons/michpalLogo/new-logo-michpal-6.png'),
	newLogo: require('../../assets/icons/newMichpalLogo/logo.png'),
	Logo: require('../../assets/icons/newMichpalLogo/logo_4x.png'),
	newLogo1p5x: require('../../assets/icons/newMichpalLogo/logo_1p5x.png'),
	newLogo2x: require('../../assets/icons/newMichpalLogo/logo_2x.png'),
	newLogo3x: require('../../assets/icons/newMichpalLogo/logo_3x.png'),
	calc_icon: require('../../assets/icons/calc/icons@2x_1.png'),
	idBadge: require('../../assets/icons/id-badge/id-badge-2.png'),
	liram: require('../../assets/icons/liramLogo/logo-liram.png'),
	login: require('../../assets/icons/login/bg.png'),
	phone: require('../../assets/icons/phone/phone.png'),
	phoneCode: require('../../assets/icons/phoneCode/phoneCode.png'),
	sandTime: require('../../assets/icons/sandTime/time.png'),
	closeWeb: require('../../assets/icons/closeWeb/combined-shape.png'),
	bluePaper: require('../../assets/icons/blue-paper/blue-paper_max.png'),
	hamburger: require('../../assets/icons/hamburger/hamburger.png'),
	showPassword: require('../../assets/icons/show-password/show-password.png'),
	hidePassword: require('../../assets/icons/hide-password/hide-password.png'),
	calendar: require('../../assets/icons/calendar/calendar.png'),
	calendar_web: require('../../assets/icons/calendar/calendar_web.png'),
	calendar_event: require('../../assets/icons/calendar/calendar_event.png'),
	calendar_checked: require('../../assets/icons/calendar-check/Vector-1.png'),
	add: require('../../assets/icons/add/add.png'),
	history: require('../../assets/icons/history/history.png'),
	question: require('../../assets/icons/question/question.png'),
	downloadPaycheck: require('../../assets/icons/downloadPaycheck/download.png'),
	attention: require('../../assets/icons/attention/attention.png'),
	arrowDown: require('../../assets/icons/arrowDown/dropdown-blue.png'),
	excel: require('../../assets/icons/excel/excel.png'),
	tableExcel: require('../../assets/icons/excel/table-shortcut.svg'),
	save: require('../../assets/icons/save/save.png'),
	back: require('../../assets/icons/back/back.png'),
	reject: require('../../assets/icons/reject/reject.png'),
	trash: require('../../assets/icons/trash/trash.png'),
	checkBox: require('../../assets/icons/checkbox/checkbox.png'),
	checked: require('../../assets/icons/checked/checked.png'),
	errorIndicaror: require('../../assets/icons/errorIndicator/errorIndicaror.png'),
	upload: require('../../assets/icons/upload/upload.png'),
	table: require('../../assets/icons/table/table.png'),
	clickedTable: require('../../assets/icons/clickedTable/table.png'),
	exit: require('../../assets/icons/exit/exit.png'),
	questionMark: require('../../assets/icons/question_mark/invalid-name.png'),
	chart: require('../../assets/icons/chart/chart.png'),
	downloadPDF: require('../../assets/icons/downloadPDF/downloadPDF.png'),
	initialCommentIcon: require('../../assets/icons/comment_icon/comment_icon.png'),
	addedCommentIcon: require('../../assets/icons/added_comment_icon/added_comment_icon.png'),
	pdf: require('../../assets/icons/pdf/pdf.png'),
	sort: require('../../assets/icons/sort/sort.png'),
	sortActive: require('../../assets/icons/sortActive/sortActive.png'),
	filter: require('../../assets/icons/filter/filter.png'),
	filterActive: require('../../assets/icons/filterActive/filterActive.png'),
	checkboxUnselected: require('../../assets/icons/checkbox-unselected/checkbox-unselected.png'),
	checkboxSelected: require('../../assets/icons/checkbox-selected/checkbox-selected.png'),
	checkedMark: require('../../assets/icons/checkedMark/checkedMark.png'),
	leftArrow: require('../../assets/icons/arrows/leftArrow.png'),
	chevronRight: require('../../assets/icons/arrows/chevron-right.svg'),
	chevronLeft: require('../../assets/icons/arrows/chevron-left.png'),
	greyChevronDown: require('../../assets/icons/chevron-down-grey/chevron-down.png'),
	extraInfo: require('../../assets/icons/extraInfo/extraInfo.png'),
	exclamationMark: require('../../assets/icons/exclamationMark/i-icon.png'),
	multipleFile: require('../../assets/icons/file-multiple/icon-file-multiple.png'),
	message: require('../../assets/icons/message/message.png'),
	closeBig: require('../../assets/icons/closeBig/closeBig.png'),
	whatsappIcon: require('../../assets/icons/whatsapp/whatsapp.png'),
	excludedIcon: require('../../assets/icons/excluded-icon/excluded-icon.png'),
	brightBlueQuestionMark: require('../../assets/icons/bright-blue-question-mark/bright-blue-question-mark.png'),
	arrowRightDown: require('../../assets/icons/arrow-white-down/arrow-white-down.png'),
	exclamationMarkRed: require('../../assets/icons/exclamationMarkRed/exclamationMarkRed.png'),
	profileDefault: require('../../assets/icons/profileDefault/profileDefault.png'),
	settings: require('../../assets/icons/settings/settings.png'),
	newSettings: require('../../assets/icons/settings/newSettings.png'),
	compare: require('../../assets/icons/compare/compare.png'),
	file: require('../../assets/icons/file/file.png'),
	rejectFile: require('../../assets/icons/rejectFile/rejectFile.png'),
	approveFile: require('../../assets/icons/approveFile/approveFile.png'),
	upArrow: require('../../assets/icons/upArrow/upArrow.png'),
	downArrow: require('../../assets/icons/downArrow/downArrow.png'),
	downArrowSvg: require('../../assets/icons/downArrow/chevron-down.svg'),
	reduceScreenArrow: require('../../assets/icons/reduceScreenArrow/ReduceScreen.png'),
	reduceScreenArrowLeft: require('../../assets/icons/reduceScreenArrowLeft/ReduceScreenLeft.png'),
	search: require('../../assets/icons/search/search.png'),
	edtitWhite: require('../../assets/icons/edtitWhite/edtitWhite.png'),
	noResults: require('../../assets/icons/noResults/noResults.png'),
	openMenu: require('../../assets/icons/openMenu/openMenu.png'),
	enterCustomer: require('../../assets/icons/enterCustomer/enterCustomer.png'),
	settingsOrange: require('../../assets/icons/settingsOrange/settingsOrange.png'),
	verticalDots: require('../../assets/icons/verticalDots/verticalDots.png'),
	redExclamationMark: require('../../assets/icons/redExclamationMark/redExclamationMark.png'),
	downloadActivePDF: require('../../assets/icons/downloadActivePDF/downloadActivePDF.png'),
	downloadDisablePDF: require('../../assets/icons/downloadDisablePDF/downloadDisablePDF.png'),
	orangePDF: require('../../assets/icons/orangePDF/orangePDF.png'),
	bell: require('../../assets/icons/bell/bell.png'),
	whitePlus: require('../../assets/icons/whitePlus/whitePlus.png'),
	checkFile: require('../../assets/icons/checkFile/checkFile.png'),
	undo: require('../../assets/icons/undo/undo.png'),
	plusWhite: require('../../assets/icons/plus_white/plus_white.png'),
	deleteCircle: require('../../assets/icons/delete_circle/delete_circle.png'),
	infoCircle: require('../../assets/icons/info-circle/info-circle.png'),
	send: require('../../assets/icons/send/send1.png'),
	shieldLock: require('../../assets/icons/shield-lock/shield-lock.png'),
	tableImport: require('../../assets/icons/table-import/table-import.png'),
	eyeOn: require('../../assets/icons/eye/eye.svg'),
	eyeOff: require('../../assets/icons/eye/eye-off.svg'),
	hide: require('../../assets/icons/hide/hide.png'),
	view: require('../../assets/icons/view/view.png'),
	enterPageArrow: require('../../assets/icons/enterPageArrow/enterPageArrow.png'),
	closePopup: require('../../assets/icons/closePopup/x.svg'),
	miniClock: require('../../assets/icons/miniCard/clock-play.svg'),
	fileDots: require('../../assets/icons/miniCard/file-dots.svg'),
	refresh: require('../../assets/icons/refresh/refresh.svg'),
	AB: require('../../assets/icons/a-b/a-b.svg'),
	chevLeft: require('../../assets/icons/chevron-left-right/chevron-left.svg'),
	chevRight: require('../../assets/icons/chevron-left-right/chevron-right.svg'),
};
